import { ArrowRight, Zap, Shield, Globe } from 'lucide-react'

export function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-transparent" />

      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      <div className="relative z-10 container mx-auto px-6 text-center max-w-5xl">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-8">
          <Zap className="w-4 h-4 text-primary" />
          <span className="font-mono text-sm text-primary uppercase tracking-wider">
            V2 IS LIVE
          </span>
        </div>

        {/* Main heading */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl font-sentient mb-8 leading-tight">
          The Future of{' '}
          <span className="text-primary italic">Machine Payments</span>
          <br />
          is Here
        </h1>

        {/* Description */}
        <p className="text-lg sm:text-xl text-foreground/60 max-w-2xl mx-auto mb-8 leading-relaxed">
          MPP Payment Gateway on ThaiChain — enabling AI agents and machines to pay for APIs
          automatically using TCH tokens. No API keys, no subscriptions, just seamless
          machine-to-machine payments.
        </p>

        {/* Features badges */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-foreground/5 border border-foreground/10">
            <Shield className="w-4 h-4 text-primary" />
            <span className="font-mono text-sm">Secure</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-foreground/5 border border-foreground/10">
            <Zap className="w-4 h-4 text-primary" />
            <span className="font-mono text-sm">Fast</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-foreground/5 border border-foreground/10">
            <Globe className="w-4 h-4 text-primary" />
            <span className="font-mono text-sm">Global</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#getting-started"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-background font-mono font-semibold rounded-lg hover:bg-primary/90 transition-colors"
          >
            Get Started
            <ArrowRight className="w-5 h-5" />
          </a>
          <a
            href="https://www.npmjs.com/package/tchcash"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 border border-foreground/20 text-foreground font-mono font-semibold rounded-lg hover:bg-foreground/10 transition-colors"
          >
            Install tchcash
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-foreground/20 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-foreground/40 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  )
}
